import header from "./expose.webp";
import section1 from "./balconies-white-swan-logo.webp";
import section2 from "./neubauprojekt-beispiel.webp";
import section3 from "./white-swan.jpg";

export { header, section1, section2, section3 };
